module.exports = __webpack_public_path__ + "files/63ca605e05b5a87d367e2259201b3dc8.png";